/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useCallback, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import 'react-awesome-slider/dist/styles.css';
import { Box } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { MotorplayContext } from '../../../context';
import { CardPayment, Loading, Modal } from './components';
import { useInjectBodyScripts, useInjectHeadScripts } from '../../../utils/hooks/useInjectScripts';
import { injectTrackingScripts } from './utils';

const PaymentPage = ({ history, user }) => {
  const {
    plans,
    selectedPlan,
    loading,
    createSubscriptionMercadopago,
    error,
    complete,
    resetError,
    openModal,
    type,
    setOpenModal
  } = useContext(MotorplayContext);
  const [summary, setSummary] = useState(null);
  const [intents, setIntents] = useState(1);
  useInjectHeadScripts();
  useInjectBodyScripts();

  const closeModal = () => {
    if (error) {
      resetError();
      setIntents(intents + 1);
    }

    if (complete) {
      injectScripts();
      const cloudpayConfig = window.AppENV.cloudpay;
      window.location.href = `${
        cloudpayConfig.baseURL
      }/redirect/goBackToReturnUrl${
        window.location.search
      }&jwt=${localStorage.getItem('jwt')}`;
      return;
    }
    setOpenModal(false);
  };

  useEffect(() => {
    if (!plans) {
      history.push('plans' + history.location.search);
      return;
    }

    if (summary) return;

    const plan = plans.find((plan) => plan.id === selectedPlan);

    setSummary({
      plan,
      total: plan.price,
      email: user.data.email,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plans]);

  const onSubmit = useCallback((data) => {
    createSubscriptionMercadopago(user.token, data.token);
  }, []);

  const injectScripts = useCallback(() => {
      injectTrackingScripts(selectedPlan, plans);
    }, [selectedPlan, plans]);

  useEffect(() => {
    if (!selectedPlan) return;

    // Remove existing scripts if they exist
    document.querySelectorAll('.tracking-script').forEach((script) => script.remove());
    const selectedPlanData = plans.find((plan) => plan.id === selectedPlan);

    // Meta Pixel Script
    const fbScript = document.createElement('script');
    fbScript.classList.add('tracking-script');
    fbScript.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '592232429092515');
      fbq('track', 'PageView');
      fbq('track', 'AddPaymentInfo', {
        content_category: '${selectedPlanData?.title}',
        value: '${selectedPlanData?.price}',
        currency: '${selectedPlanData?.currency}'
      });
    `;
    document.body.appendChild(fbScript);

    // NoScript Image for Meta Pixel
    const noScript = document.createElement('noscript');
    noScript.innerHTML = `
      <img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=592232429092515&ev=PageView&noscript=1"/>
    `;
    document.body.appendChild(noScript);

    // Google dataLayer
    const gtmScript = document.createElement('script');
    gtmScript.classList.add('tracking-script');
    gtmScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        ecommerce: null
      });
      dataLayer.push({
        event: "add_payment_info",
        ecommerce: {
          currency: "${selectedPlanData?.currency}",
          value: "${selectedPlanData?.price}",
          items: [{
            item_category: "${selectedPlanData?.title}",
            price: "${selectedPlanData?.price}"
          }]
        }
      });
    `;
    document.body.appendChild(gtmScript);
  }, [selectedPlan, plans]);

  return (
    <>
      {loading && <Loading />}
      {openModal && type && <Modal type={type} closeModal={closeModal} message={error} />}
      <Box sx={{ width: '100%' }} className='MembershipSelectionPage'>
        <Box className='myaccount-title'>
          <h2 className='text-title'>
            <FormattedMessage id='Summary.dlocalForm.title' />
          </h2>
        </Box>
        {summary && (
          <Box className='payment-box'>
            <div className='summary'>
              <div className='summary__item'>
                <p>{summary.plan.title}</p>
                <p>{summary.plan.price}</p>
              </div>

              <div className='summary__total'>
                <p>Total a pagar</p>
                <p>{summary.total}</p>
              </div>
            </div>
          </Box>
        )}
        <div className='payment-box mt-4'>
          {summary && (
            <CardPayment
              amount={summary.total}
              email={summary.email}
              onSubmit={onSubmit}
              intents={intents}
            />
          )}
        </div>
      </Box>
    </>
  );
};

PaymentPage.defaultProps = {};

PaymentPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
    location: PropTypes.shape({
      search: PropTypes.string,
    }).isRequired,
  }),
  user: PropTypes.object,
  client: PropTypes.string.isRequired,
};
export default PaymentPage;
